import PropTypes from 'prop-types';
import React, { useEffect, useMemo } from 'react';
import { connect, useDispatch } from 'react-redux';
import Select from 'react-select';

import { getAddressDatasources } from '@redux/actions/myAddress';
import SitecoreContextFactoryService from '@services/sitecoreContextFactoryService';

import LoadingMask from '../../../../../Share/LoadingMask';
import useSelectStoreAndDateContext from '../../../useSelectStoreAndDateContext';

export const AREA_OPTIONS_NAME = 'areas';

const AreaSelect = ({ options, isLoading, ...props }) => {
  const { layoutData } = useSelectStoreAndDateContext();
  const dispatch = useDispatch();

  const siteName = useMemo(() => {
    return SitecoreContextFactoryService.getValueContextItem('site')?.name?.replace('O', '');
  }, []);

  const areaSelectOptions = useMemo(() => {
    const areaOptionsTemp = [];
    if (options && options[AREA_OPTIONS_NAME]?.length) {
      for (const option of options[AREA_OPTIONS_NAME]) {
        areaOptionsTemp.push({
          label: option.Display,
          value: option.value
        });
      }
    }

    return areaOptionsTemp;
  }, [options]);

  useEffect(() => {
    if (!Object.keys(options).length)
      dispatch(
        getAddressDatasources({
          model: {
            CountryCode: siteName || 'SG',
            RootValue: '',
            RootType: '',
            ChildType: ''
          },
          fieldName: AREA_OPTIONS_NAME,
          condition: null
        })
      );
  }, []);

  return (
    <>
      <Select
        {...props}
        className='customization-dropdown'
        classNamePrefix='customization-dropdown'
        isSearchable={false}
        id='area-selector'
        name='area-selector'
        placeholder={layoutData?.areaLabel?.value || layoutData?.['Area Label']?.value}
        options={areaSelectOptions}
      />
      {isLoading ? <LoadingMask /> : <></>}
    </>
  );
};

AreaSelect.propTypes = {
  options: PropTypes.any,
  isLoading: PropTypes.bool
};

const mapStateToProps = (state) => ({
  options: state.myAddressReducer.addressDatasourcesReducer.options,
  isLoading: state.myAddressReducer.addressDatasourcesReducer.isLoading
});

export default connect(mapStateToProps)(AreaSelect);
